import { parseAsInteger, parseAsString, useQueryState } from 'nuqs';
import { useEffect } from 'react';
import { useDebounce } from "use-debounce";

type ProductType = 'products' | 'coproducers' | 'affiliates' | 'referral_links';

export const useProductsState = () => {
  const [tab, setTab] = useQueryState(
    'tab',
    parseAsString.withDefault('products')
  );
  const [search, setSearch] = useQueryState(
    'search',
    parseAsString.withDefault('')
  );
  const [status, setStatus] = useQueryState(
    'status',
    parseAsString.withDefault('all')
  );
  const [page, setPage] = useQueryState('page', parseAsInteger.withDefault(1));

  const [debouncedSearch] = useDebounce(search, 450);

  // useEffect(() => {
  //   setSearch("")
  // }, [tab])

  useEffect(() => {
    if (page > 1) {
      setPage(1);
    }
  }, [tab, search, status, setPage]);

  return {
    tab: tab as ProductType,
    setTab,
    search,
    setSearch,
    status,
    setStatus,
    page,
    setPage,
    debouncedSearch,
  };
}
